const state = {
  classInfo: {} // 课程概况
}

const getters = {

}

const actions = {

}

const mutations = {

}

export default {
  state,
  getters,
  actions,
  mutations
}
